/**
 * A persistent strip naming the environment, shown on every page of every
 * non-production build, so nobody mistakes the staging admin for the live one.
 *
 * The values are fixed at build time in vite.config.js. The host is the backend
 * the /api proxy forwards to, because that is what decides which data you see.
 */
const VARIANT = import.meta.env.VITE_APP_VARIANT;
const BUILD = import.meta.env.VITE_BUILD_ID;
const API_ORIGIN = import.meta.env.VITE_API_ORIGIN;

export default function EnvironmentBanner() {
  if (VARIANT === "production") return null;

  const host = API_ORIGIN
    ? API_ORIGIN.replace(/^https?:\/\//, "").replace(/\/+$/, "")
    : "NO API URL SET";
  const label = [(VARIANT || "local").toUpperCase(), BUILD, host]
    .filter(Boolean)
    .join(" · ");

  return (
    <div
      role="alert"
      title={label}
      className="sticky top-0 z-50 truncate bg-[#7C3AED] px-2.5 py-[3px] text-center text-[11px] font-bold tracking-wide text-white"
    >
      {label}
    </div>
  );
}
